module.exports = __webpack_public_path__ + "media/images/pc/top/recommend-plan-wedding1-354a01fdb2e1b97d6141fb296c4e83c3.jpg";